import { createSvgIcon } from '@mui/material';
import Styled from "./custom-styled-icon";

export const Refresh = Styled(
  createSvgIcon(
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.125 18.0584C15.7 17.1167 18.3333 13.8667 18.3333 10C18.3333 5.40002 14.6333 1.66669 9.99999 1.66669C4.44166 1.66669 1.66666 6.30002 1.66666 6.30002M1.66666 6.30002V2.50002M1.66666 6.30002H3.34166H5.36666" stroke="#1F2125" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1.66666 10C1.66666 14.6 5.39999 18.3333 9.99999 18.3333" stroke="#1F2125" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="3 3"/>
</svg>
,
    "Refresh",
  ),
);

export default Refresh;
